export {default} from "./ImageAndText";
export * from "./ImageAndText";
